var _defs, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-16d135fe-e8e1-4c80-8a0a-e52e2895dc23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72v0v-72v0h72v0v72v0z"
  })))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3308"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 2520")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-16d135fe-e8e1-4c80-8a0a-e52e2895dc23)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5851"), /*#__PURE__*/React.createElement("path", {
    d: "M41.434,41.863c0.913,-0.555 1.735,-3.147 1.735,-3.147c6.668,4.256 4.645,19.017 -6.942,18.421c-5.655,-0.255 -7.917,-3.644 -8.811,-6.642c-0.747,-2.652 -0.643,-5.472 0.297,-8.062c3.397,-9.793 13.353,-10.57 13.353,-10.57c-3.377,6.388 0.368,9.999 0.368,10z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-16d135fe-e8e1-4c80-8a0a-e52e2895dc23)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5852"), /*#__PURE__*/React.createElement("path", {
    d: "M24.59,29.305c-2.318,-1.405 -4.407,-7.965 -4.407,-7.965c-16.93,10.772 -11.793,48.125 17.629,46.616c14.359,-0.643 20.104,-9.221 22.373,-16.807c1.896,-6.712 1.633,-13.847 -0.753,-20.401c-8.626,-24.783 -33.908,-26.748 -33.908,-26.748c8.577,16.165 -0.934,25.302 -0.934,25.305z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelType1);
export default __webpack_public_path__ + "static/media/fuel-type-1.8face62bf7be5e0184c033f8e6ffa574.svg";
export { ForwardRef as ReactComponent };